module.exports = __webpack_public_path__ + "img/pro.3755efd6.png";